<template>
    <div>
        <div v-if="videos != null">
            <div id="convert-result"
                class="row col-lg-8 col-md-10 col-12 mx-auto mt-5 alert alert-primary shadow-lg convert-result"
                role="alert">
                <div class="container">
                    <p class="convert-title">Download video as:</p>
                </div>
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-4 col-lg-4 order-12 order-lg-1 mt-3 mx-auto result-col-thumb">
                            <img class="card-img-top img-fluid rounded" :src="thumb" :alt="meta.title">
                            <h6>{{ stringShorter(meta.title, 20) }}</h6>
                            <p>Duration: {{ meta.duration }}</p>
                        </div>
                        <div class="col-12 col-lg-8 order-2">
                            <div class="col-12 p-0 m-0">
                                <div class="tabs-header row">
                                    <a class="video-title col-12 m-0 active-tab">
                                        <span><i class="fab fa-youtube"></i> Video </span>
                                    </a>
                                </div>
                            </div>
                            <div class="row m-0">
                                <div class="d-lg-block p-0 col-12">
                                    <div id="myTabContent" class="tab-content">
                                        <div id="nav-mp4" class="tab-pane active show">
                                            <table class="table table-dark table-striped table-sm mb-0" cellspacing="0">
                                                <tr v-for="(video) in videosList" :key="video.url">
                                                    <td scope="row"
                                                        v-bind:class="{ 'no-audio': video.no_audio, 'audio': !video.no_audio }">
                                                        <span><strong class="quality">{{ video.quality }}</strong>.{{
            video.ext }}</span>
                                                        <span class="no-audio-icon" v-if="video.no_audio"><i
                                                                class="fas fa-volume-mute"></i></span>
                                                        <span class="audio-only-icon" v-if="video.audio"
                                                            title="Audio only"><i class="fas fa-music"></i></span>
                                                    </td>
                                                    <td class="align-middle"
                                                        v-bind:class="{ 'no-audio': video.no_audio }">
                                                        <a class="btn"
                                                            :id="'download-' + video.ext + '-' + video.quality + '-' + (video.no_audio ? 'no-audio' : 'audio')"
                                                            @click="download(video.url, meta.title + video.ext, video)">
                                                            <i class="fas fa-download"></i> Download
                                                        </a>
                                                    </td>
                                                </tr>
                                            </table>
                                            <div @click="showMore = !showMore" class="show-more-button"
                                                v-if="videos.length > listDefaultLength">
                                                <span>{{ showMore ? "Show less" : "Show more" }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="videos === null && manyElements !== null">
            <!-- Карточки плейлиста — по образцу ddown.to (стили в _find.scss) -->
            <div class="container text-white mt-5 find-section">
                <!-- 1–2 карточки: ширина колонки как у полной строки, по центру (results-grid--count-N в _find.scss) -->
                <div class="results-grid"
                    :class="manyElements.length < 3 ? 'results-grid--count-' + manyElements.length : null">
                    <!-- карточка — PlaylistCard.vue; состояние, запрос форматов, GA и эксперимент — здесь -->
                    <playlist-card v-for="(manyElement, index) in manyElements"
                        :key="manyElement.inline ? 'pl-' + index : manyElement.url[0].url" :ref="'pl-card-' + index"
                        :element="manyElement" :index="index" :open="openQuality === index"
                        @load="loadFormats(manyElement, index)" @toggle="toggleQualityList(index)"
                        @close="openQuality = null" @select="selectFormat(manyElement, $event)"
                        @download="downloadSelected(manyElement, $event)" @download-direct="downloadMany(manyElement)" />
                </div>
            </div>
        </div>

        <div v-if="error">
            <ErrorBlock :error="error" />
        </div>
        <loader-component v-if="isLoading" :isLoading="isLoading"></loader-component>

    </div>
</template>

<script>
import ErrorBlock from "./ErrorBlock";
import LoaderComponent from "./LoaderComponent";
import PlaylistCard from "./PlaylistCard.vue";
import stringShorter from '../tools/stringShorter'
import { showConverterUIPopup } from '../tools/showConverterUIPopup'
import { expBus } from '@js-packages/experiment-loader';
import domainDictionary from '../tools/domainDictionary';
import { NOT_FOUND_MESSAGE, postConvert, parseVideoResponse, parseConvertError } from '../tools/convertFormats';

// watch-URL элемента плейлиста. meta.source целиком не берём: он может совпадать со ссылкой плейлиста.
// Кандидаты id перебираются по порядку, берётся первый, похожий на id YouTube.
function playlistItemWatchUrl(el) {
    const src = (el.meta && el.meta.source) || '';
    const m = src.match(/[?&]v=([\w-]{11})/);
    const id = [el.id, el.meta && el.meta.id, m && m[1]]
        .map((c) => String(c || ''))
        .find((c) => /^[\w-]{11}$/.test(c));
    return id ? `https://www.youtube.com/watch?v=${id}` : null;
}

// Ссылка ведёт на YouTube (со схемой, `//` или без): inline-форматы строят watch-URL YouTube,
// поэтому включаются только для результатов по ссылке YouTube. Логин:пароль@ перед хостом пропускается.
// Обратная косая черта завершает хост, как в браузере (для http/https это разделитель пути).
// Хост сверяется тем же domainDictionary, что даёт event_label GA (101 — YouTube).
function isYoutubeLink(link) {
    const m = String(link || '').trim().match(/^(?:(?:[a-z][\w+.-]*:)?\/\/)?(?:[^/\\?#@\s]*@)?([^/\\?#:@\s]+)/i);
    return !!m && domainDictionary(m[1]) === 101;
}

function getBetterQualities(data) {
  if (!data || !Array.isArray(data.video_quality) || !Array.isArray(data.url)) {
    return false;
  }
  const hostingYt = data.hosting === '101';

  if (!hostingYt) return false;

  const ytQuality = data.video_quality.map((q) => parseInt(q, 10)).filter((q) => q > 0);
  const videoQualities = data.url
    .filter(i => i.name === 'MP4' && (i.no_audio === false || i.no_audio === undefined))
    .map(i => i.qualityNumber || parseInt(i.quality) || 0)
    .filter(q => q >= 480);

  const maxVideoQuality = Math.max(...videoQualities, 480);
  const ytMaxQuality = Math.max(...ytQuality, 480);

  if (ytMaxQuality === maxVideoQuality) {
    return false;
  }

  const better = ytQuality.filter((q) => q > maxVideoQuality);
  better.duration = data.meta && data.meta.duration;
  return better;
}

export default {
    components: {
        ErrorBlock,
        LoaderComponent,
        PlaylistCard,
    },
    name: 'MainResults',
    props: {
        activBtn: String,
        searchUrlInsPosts: String,
        searchUrlInsReels: String,
        highlightStories: Array,
        stories: Array,
        canonical: String
    },
    data() {
        return {
            videos: null,
            meta: null,
            link: null,
            thumb: null,
            error: null,
            showMore: false,
            listDefaultLength: 3,
            manyElements: null,
            linkStories: null,
            linkPosts: null,
            rootOnSearchResults: false,
            label: '',
            requestStartDate: 0,
            isLoading: false,
            // индекс карточки плейлиста с открытым списком качеств; открыт не больше одного
            openQuality: null
        }
    },
    mounted() {
        this.$root.$on('clear-results', () => {
            this.videos = null;
            this.meta = null;
            this.thumb = null;
            this.error = null;
            this.showMore = false;
            this.link = null;
            this.rootOnSearchResults = false;
            this.manyElements = null;
            this.openQuality = null;
            // tzPlatformLinks: наблюдатели показа убранных таблиц и списков отключаются сразу, а не на следующем tzBestQuality
            expBus.emit('tzReset');
        });
        // список качеств карточки плейлиста закрывается кликом вне него и Escape
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onDocumentKeydown);

        if (this.highlightStories) {
            this.videos = null
            this.manyElements = this.highlightStories
        }
        this.$root.$on('link-submit', (link) => {
            document.getElementById('main-form').scrollIntoView();
            this.link = link.trim();
            this.request(link);
        });
        if (this.activBtn) {
            document.getElementById('main-form').scrollIntoView();

            if (this.activBtn === 'posts' && this.searchUrlInsPosts) {
                this.$root.$emit('link-submit-posts', this.searchUrlInsPosts)
                this.linkPosts = this.searchUrlInsPosts;
                this.manyElements = null
                this.rootOnSearchResults = true;
                if (this.linkPosts && this.linkStories !== this.linkPosts) {
                    this.request(this.linkPosts);
                }
            }
            if (this.activBtn === 'stories') {
                this.manyElements = null;
                this.rootOnSearchResults = true;
                if (this.stories) {
                    this.videos = null
                    this.manyElements = this.stories
                }
                if (!this.manyElements) {
                    this.$emit('loadStories')
                } else {
                    if (this.stories === null) {
                        this.error = { message: 'Something went wrokng. Try later' }
                    } else if (!this.stories.length) {
                        this.error = { message: 'It seems that there are no stories for the last 24 hours' }
                    }
                }
            }
            if (this.activBtn === 'reels' && this.searchUrlInsReels) {
                this.$root.$emit('link-submit-reels', this.searchUrlInsReels)
                this.linkReels = this.searchUrlInsReels;
                this.manyElements = null;
                this.rootOnSearchResults = true;
                if (this.linkReels && this.linkReels !== this.linkPosts) {
                    this.request(this.linkReels);
                };
            }
        }

    },
    beforeDestroy() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onDocumentKeydown);
    },
    watch: {
        stories: function (newVal) {
            if (!newVal.length) {
                this.error = { message: 'It seems that there are no stories for the last 24 hours' }
            } else {
                this.error = null
                this.manyElements = newVal
            }
        },
    },
    methods: {
        // startDate — старт запроса, который завершился ошибкой (send-error-time); по умолчанию — основной поиск.
        // Inline-запрос карточки плейлиста передаёт свой старт: время до ошибки считается от клика «Choose quality».
        handleError(result, startDate = this.requestStartDate) {
            this.$root.$emit('show-error', result, this.link);
            this.$root.$emit('send-error-time', startDate, this.link);
        },
        stringShorter(string, length) {
            return stringShorter(string, length)
        },
        startLoading() {
            this.isLoading = true
        },
        endLoading() {
            this.isLoading = false
        },
        async request(link) {
            this.requestStartDate = Date.now();
            const statusState = { status: false };
            if (statusState.status) return;

            const body = await this.$root.subscribeSignedRequestBody(link.replace('?source=search', ''));
            this.startLoading()
            postConvert(body).then((success) => {
                if (success.data?.length > 1 && success.data[1].url) {
                    this.$root.$emit('show-results', success.data[0], this.link, 'mp4');

                    const youtube = isYoutubeLink(link);
                    const data = success.data.map(elem => {
                        elem.url = elem.url.filter((item) => item.type === 'mp4' || !['reels', 'stories'].includes(this.activBtn))
                        // Элемент без прямой ссылки (видео плейлиста YouTube): форматы грузятся по клику «Choose quality».
                        // Состояние задаётся до присваивания в manyElements, чтобы Vue 2 сделал его реактивным.
                        if (youtube && !(elem.url[0] && elem.url[0].url)) {
                            elem.inline = { watchUrl: playlistItemWatchUrl(elem), loading: false, error: null, formats: null, selected: 0 };
                        }
                        return elem
                    // элемент с inline-состоянием остаётся и с пустым url: форматы грузятся по клику
                    }).filter(elem => elem.inline || elem.url.length)

                    this.openQuality = null;
                    return this.manyElements = data
                }
                if (!success.data.length && this.activBtn) {
                    this.label = 'It seems that there are no stories for the last 24 hours'
                    return this.handleError(this.label)
                }

                // blacklist — только GA; 200 без форматов (например { success: false, response_type: 'link not found' })
                // — ошибка «не найдено», как ответ 404, без show-results
                const parsed = parseVideoResponse(success.data);
                if (parsed.error) {
                    this.handleError(parsed.error);
                    if (!parsed.blacklist) {
                        this.label = NOT_FOUND_MESSAGE;
                        this.error = { message: NOT_FOUND_MESSAGE };
                    }
                    return;
                }
                this.$root.$emit('show-results', success.data, this.link, 'mp4');
                this.videos = parsed.formats;
                this.meta = success.data.meta;
                this.thumb = success.data.thumb;
                // window.videos — как до показа аудио-дорожек в таблице: только видео
                window.videos = this.videos.filter((item) => item.audio !== true);
                const betterQuality = getBetterQualities(success.data);
                if (betterQuality) {
                    // после отрисовки таблицы качеств: модуль tzPlatformLinks ищет #nav-mp4 table при получении события
                    this.$nextTick(() => expBus.emit('tzBestQuality', betterQuality));
                }
            }).catch((e) => {
                const err = parseConvertError(e);
                this.handleError(err.ga);
                // блок ошибки — только на ответ со status >= 400 (401 — без текста, как раньше); таймаут — только GA
                if (err.status) {
                    this.label = err.message;
                    this.error = err.status === 401 ? true : { message: err.message };
                }
            }).finally(() => {
                this.$root.$emit('result-end');
                this.endLoading()
            });


        },
        sendToForm(url) {
            localStorage.setItem("search", url);
            document.location = this.canonical;
        },
        download(link, download, videoObj) {
            // Check if this is a converter link
            const isConverterLink = videoObj?.isConverterUI ||
                                   (link && (link.includes('popup=true') || link.includes('sf-converter.com')));

            if (isConverterLink) {
                // GA — единственный ресурс сайта G-C99JLJT0GY (analytics.blade.php), без отдельного ресурса
                if (window.gtag) {
                    window.gtag('event', 'converter_link_click');
                }

                const clickAdsExperiment = window['clickAds'];

                showConverterUIPopup(
                    videoObj?.url || link,
                    '#dc3545',
                    clickAdsExperiment?.url || ''
                );

                return;
            }

            this.$root.$emit('download-click', this.link, 'mp4');

            setTimeout(() => {
              const a = document.createElement('a');
              a.href = link;
              a.rel = 'noreferrer';
              document.body.appendChild(a);
              a.click();
              a.remove();
            }, 500);
        },

        // Inline-форматы элемента плейлиста: клик грузит форматы по watch-URL; после загрузки кнопка
        // «Choose quality» убирается (v-if), на её месте выбор качества (выпадающий список, выбран первый формат)
        // и Download выбранного формата; после ошибки клик повторяет запрос.
        // Общие isLoading/error/videos не трогаются: основной результат остаётся на месте.
        async loadFormats(el, index) {
            const st = el.inline;
            // форматы уже загружены — кнопки нет, повторного запроса не бывает
            if (st.loading || st.formats) return;
            st.error = null;
            if (!st.watchUrl) {
                st.error = NOT_FOUND_MESSAGE;
                return;
            }
            st.loading = true;
            // Ответ, пришедший после нового поиска или очистки результатов, в GA не идёт:
            // this.link и requestStartDate уже относятся к другой ссылке.
            const link = this.link;
            // элемент на своём индексе — значит, он и в списке: новый поиск или очистка заменяют manyElements
            const current = () => this.link === link && (this.manyElements || [])[index] === el;
            // send-error-time — от клика «Choose quality», а не от основного поиска (requestStartDate)
            const startDate = Date.now();
            let shown = null;
            try {
                const body = await this.$root.subscribeSignedRequestBody(st.watchUrl);
                const { data } = await postConvert(body);
                // разбор ответа и GA — как у одиночного видео (parseVideoResponse)
                const parsed = parseVideoResponse(data);
                if (parsed.error) {
                    st.error = NOT_FOUND_MESSAGE;
                    if (current()) this.handleError(parsed.error, startDate);
                    return;
                }
                st.formats = parsed.formats;
                shown = data;
            } catch (e) {
                const err = parseConvertError(e);
                st.error = err.message;
                if (current()) this.handleError(err.ga, startDate);
            } finally {
                st.loading = false;
            }
            // show-results — вне try: сбой обработчика GA не должен превращать загрузку в ошибку и not_found.
            // Шлётся один раз: после загрузки кнопки нет, а повторный вызов выходит на guard st.formats выше.
            // Ссылка плейлиста this.link даёт тот же event_label (101), что и watch-URL одиночного видео.
            if (shown && current()) {
                this.$root.$emit('show-results', shown, this.link, 'mp4');
                this.emitBestQuality(index, shown, current);
            }
        },

        // tzPlatformLinks: строки лучших качеств — в выпадающий список карточки (поле list), а не в таблицу
        // одиночного видео. Один emit на карточку: вызывается только после первой загрузки форматов, список после неё
        // остаётся в DOM (v-show) и скрывается до открытия — show эксперимента уходит, когда строки видны.
        emitBestQuality(index, data, current) {
            const better = getBetterQualities(data);
            if (!better) return;
            this.$nextTick(() => {
                // ref внутри v-for — массив; список мог смениться новым поиском, пока ждали отрисовки
                const card = (this.$refs['pl-card-' + index] || [])[0];
                const list = card && card.$refs.list;
                if (!current() || !list) return;
                better.list = list;
                expBus.emit('tzBestQuality', better);
            });
        },

        selectFormat(el, vi) {
            el.inline.selected = vi;
            this.openQuality = null;
        },
        // открытие списка одной карточки закрывает список другой
        toggleQualityList(index) {
            this.openQuality = this.openQuality === index ? null : index;
        },
        // video — выбранный формат карточки (PlaylistCard, computed selected)
        downloadSelected(el, video) {
            this.openQuality = null;
            this.download(video.url, el.meta.title + video.ext, video);
        },
        onDocumentClick(e) {
            if (this.openQuality === null) return;
            const card = (this.$refs['pl-card-' + this.openQuality] || [])[0];
            const root = card && card.$refs.quality;
            if (!root || !root.contains(e.target)) this.openQuality = null;
        },
        onDocumentKeydown(e) {
            if (this.openQuality !== null && (e.key === 'Escape' || e.key === 'Esc')) this.openQuality = null;
        },

        downloadMany(manyElement) {
            // нет прямой ссылки — meta.source, как до карточек плейлиста
            const downloadUrl = manyElement.url?.[0]?.url || manyElement.meta?.source;
            if (downloadUrl) {
                this.download(downloadUrl, manyElement.meta.title + manyElement.ext, manyElement);
            }
        },

        convert() {
            return this.$root.$emit('convert-link', this.link);
        },
    },
    computed: {
        videosList() {
            return this.showMore ? this.videos : this.videos.slice(0, this.listDefaultLength)
        }
    }
}

</script>
